import { useAppStore } from '~/stores'

interface LinkBaseI {
  rel: string
  hreflang?: string
}

interface LinkTagI extends LinkBaseI {
  href: string
}

type LocaleT = 'lv' | 'en'

interface PathI extends LinkBaseI {
  locale: LocaleT
}

interface SlugsI {
  lv: string
  en: string
}

const X_DEFAULT_LOCALE = 'en'

export function useSEOPaths() {
  const appStore = useAppStore()
  const config = useRuntimeConfig()
  const { locale } = useI18n()

  const linkTags: LinkTagI[] = []
  const slugs: SlugsI = appStore.slugs
  const baseUrl: string = config.public.baseUrl

  ;(PATHS(locale.value as LocaleT) as PathI[]).forEach(({ locale, hreflang, rel }) => {
    const baseLinkTag: LinkTagI = {
      rel,
      href: `${baseUrl}${slugs[locale]}`
    }

    if (hreflang) {
      baseLinkTag.hreflang = hreflang
    }

    linkTags.push(baseLinkTag)
  })

  useHead({
    link: linkTags as any
  })
}

const PATHS = (locale: LocaleT) => {
  const alterLocale = locale === 'en' ? 'lv' : 'en'

  return [
    {
      rel: 'canonical',
      locale
    },
    {
      rel: 'alternate',
      locale: X_DEFAULT_LOCALE,
      hreflang: 'x-default'
    },
    {
      rel: 'alternate',
      locale: alterLocale,
      hreflang: alterLocale
    }
  ]
}
